import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import Alerts from './Alerts';
import GuestCharging from './GuestCharging';
import LiveLogsSession from './LiveLogsSession';
import StationActivity from './StationActivity';
import StationDetails from './StationDetails';
import Transactions from './Transactions';
import UpcomingMaintenanceSchedule from './UpcomingMaintenanceSchedule';
import Uptime from './Uptime';

interface StationDetailsTabProperties {
  label: string;
  key: string;
  isActive: boolean;
}

/**
 * Station management bottom container component
 * @returns {React.JSX.Element} The station management bottom container.
 */
function StationManagementBottomContainer() {
  const { t } = useTranslation('stationManagement');
  const [stationDetailsTab, setStationDetailsTab] = useState<StationDetailsTabProperties[]>([
    {
      label: 'stationDetailsTab',
      key: 'stationDetails',
      isActive: true,
    },
    {
      label: 'stationActivity',
      key: 'stationActivity',
      isActive: false,
    },
    {
      label: 'liveLogsSession',
      key: 'liveLogsSession',
      isActive: false,
    },
    {
      label: 'alerts',
      key: 'alerts',
      isActive: false,
    },
    {
      label: 'transactions',
      key: 'transaction',
      isActive: false,
    },
    {
      label: 'guestChargingLabel',
      key: 'guestCharging',
      isActive: false,
    },
    {
      label: 'upcomingMaintenanceSchedule',
      key: 'upcomingMaintenanceSchedule',
      isActive: false,
    },
    {
      label: 'uptime',
      key: 'upTime',
      isActive: false,
    },
  ]);

  /**
   * Function to switch the tab
   * @param {string} key The tab key.
   */
  const handleSwitchTab = (key: string) => {
    setStationDetailsTab((previousTabs) =>
      previousTabs.map((tab) => ({
        ...tab,
        isActive: tab.key === key,
      })),
    );
  };

  return (
    <div className="station-management-bottom-wrap">
      <div className="station-management-bottom-tab">
        {stationDetailsTab.map((tab) => (
          <div
            key={tab.key}
            className={`each-tab ${tab.isActive ? 'active' : ''}`}
            role="presentation"
            onClick={() => handleSwitchTab(tab.key)}>
            <h6>{t(tab.label)}</h6>
            <div className="bottom-green" />
          </div>
        ))}
      </div>
      <div className="station-management-bottom-container">
        {(() => {
          const activeTab = stationDetailsTab.find((tab) => tab.isActive);
          switch (activeTab?.key) {
            case 'stationDetails':
              return <StationDetails />;
            case 'stationActivity':
              return <StationActivity />;
            case 'liveLogsSession':
              return <LiveLogsSession />;
            case 'alerts':
              return <Alerts />;
            case 'transaction':
              return <Transactions />;
            case 'guestCharging':
              return <GuestCharging />;
            case 'upcomingMaintenanceSchedule':
              return <UpcomingMaintenanceSchedule />;
            case 'upTime':
              return <Uptime />;
            default:
              return null;
          }
        })()}
      </div>
    </div>
  );
}

export default StationManagementBottomContainer;
